import {ClassUtil} from "./class-util"

export class BrowserSupport {
    // See http://www.mattburkedev.com/dom-exception-22-quota-exceeded-on-safari-private-browsing-with-localstorage/
    // for more information.
    static isLocalStorageSupportedAndActive() {
        if (window.localStorage) {
            const test = '__localstoragetest__';

            try {
                window.localStorage.setItem(test, test);
                window.localStorage.removeItem(test);
            } catch (ex) {
                return false;
            }

            return true;
        }

        return false;
    }

    static isIE() {
        return (navigator.userAgent.indexOf('MSIE') !== -1)
            || (navigator.appVersion.indexOf('Trident/') > 0);
    }

    static isSafariTo10() {
        let isSafari = navigator.userAgent.indexOf('Safari') !== -1 &&
                       navigator.userAgent.indexOf('Chrome') === -1 &&
                       navigator.userAgent.indexOf('Android') === -1
        let SafariVersion = new RegExp(/(?:Version\/)(\d+)/).exec(window.navigator.userAgent)

        return isSafari && SafariVersion && parseInt(SafariVersion[1]) <= 10
    }
}
